<div class="eating" [style.background-image]="this.statesService.backgroundImageSrc + statesService.imageNumber + '.webp)'"></div>
